module.exports = __webpack_public_path__ + "img/ghgz.caff4670.svg";